import { FormBase } from 'core/components';

export default class DescriptionForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'description',
					label: 'DESCRIPTIONMODAL.DESCRIPTION',
					rules: 'required|string',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/DescriptionForm.js